import { render, staticRenderFns } from "./CashCallDocumentUploader.vue?vue&type=template&id=067d3f36&scoped=true"
import script from "./CashCallDocumentUploader.vue?vue&type=script&lang=js"
export * from "./CashCallDocumentUploader.vue?vue&type=script&lang=js"
import style0 from "./CashCallDocumentUploader.vue?vue&type=style&index=0&id=067d3f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d3f36",
  null
  
)

export default component.exports